const messages: Record<string, string> = {
  'site.title':           'Metha · docs',
  'site.tagline':         'Financement on-chain de la recherche biomédicale.',
  'nav.search':           'Rechercher dans la documentation…',
  'search.empty':         'Aucun résultat.',
  'search.unavailable':   'Index de recherche non compilé. Exécutez `npm run build` puis `npm run preview`.',
  'nav.dapp':             'Ouvrir la dapp',
  'toc.onThisPage':       'Sur cette page',
  'nav.home':             'Accueil',
  'sidebar.toggle':       'Afficher/masquer la navigation',
  'theme.toggle':         'Changer de thème',
  'lang.switch':          'Langue',
  'home.cta.lab':         'Je suis un laboratoire',
  'home.cta.auditor':     'Je suis un auditeur',
  'home.cta.learn':       'Je veux comprendre',
  'home.section.start':   'Démarrer',
  'home.section.status':  'État en direct',
  'home.section.recent':  'Ajouts récents',
  'page.lastUpdated':     'Dernière mise à jour',
  'page.editOnGithub':    'Modifier cette page sur GitHub',
  'page.onThisPage':      'Sur cette page',
  '404.title':            'Page introuvable',
  '404.body':             'La page demandée n’existe pas.',
  '404.back':             'Retour à l’accueil',

  // pied de page
  'community':            'Communaute',
  'code':                 'Code et publications',
  'onchain':              'On-chain (Sepolia)',
  'disclaimer':           'Logiciel experimental, sans garantie. METH est concu comme un instrument de reglement et de gouvernance, et non comme un titre d investissement ni comme un droit de rachat sur les actifs de Metha. Rien sur ce site ne constitue un conseil juridique, fiscal, financier ou en investissement. Consultez le registre des risques pour les expositions reglementaires et techniques connues.',

  // ── sections du manifest ──
  'manifest.section.overview':     'Aperçu',
  'manifest.section.how-it-works': 'Comment ça marche',
  'manifest.section.architecture': 'Architecture',
  'manifest.section.concepts':     'Concepts fondamentaux',
  'manifest.section.guides':       'Guides utilisateurs',
  'manifest.section.security':     'Sécurité',
  'manifest.section.risks':        'Risques',
  'manifest.section.future':       'Développements futurs',
  'manifest.section.literature':   'Littérature',
  'manifest.section.glossary':     'Glossaire',
  'manifest.section.faq':          'FAQ',
  'manifest.section.changelog':    'Changelog',

  // ── feuilles du manifest ──
  'manifest.leaf.overview':                    'Qu’est-ce que Metha',
  'manifest.leaf.why-dvbc':                    'Pourquoi DVBC',
  'manifest.leaf.status':                      'État et feuille de route',
  'manifest.leaf.how-it-works/value-loop':     'La boucle de valeur',
  'manifest.leaf.how-it-works/auctions':       'Enchères périodiques',
  'manifest.leaf.how-it-works/requests':       'Demandes de financement',
  'manifest.leaf.how-it-works/consensus':      'Consensus d’auditeurs',
  'manifest.leaf.how-it-works/governance':     'Gouvernance',
  'manifest.leaf.architecture':                'Schéma du système',
  'manifest.leaf.architecture/contracts':      'Six contrats',
  'manifest.leaf.architecture/data-flow':      'Flux de données',
  'manifest.leaf.architecture/evolution':      'Registre de slots et évolution',
  'manifest.leaf.concepts/dvbc':               'DVBC',
  'manifest.leaf.concepts/three-conditions':   'Trois conditions',
  'manifest.leaf.concepts/mechanisms-abc':     'Mecanismes A / B / C',
  'manifest.leaf.concepts/typed-deliverables': 'Livrables typés',
  'manifest.leaf.concepts/barda-option':       'Option-période BARDA',
  'manifest.leaf.concepts/dsmb-veto':          'Veto DSMB',
  'manifest.leaf.concepts/slashing':           'Niveaux de slashing',
  'manifest.leaf.guides/lab':                  'Pour les laboratoires',
  'manifest.leaf.guides/auditor':              'Pour les cabinets auditeurs',
  'manifest.leaf.guides/holder':               'Pour les détenteurs de tokens',
  'manifest.leaf.guides/dsmb':                 'Pour les membres DSMB',
  'manifest.leaf.guides/program-officer':      'Pour les Program Officers',
  'manifest.leaf.guides/developer':            'Pour les développeurs',
  'manifest.leaf.guides/developer/mdx-components': 'Reference des composants MDX',
  'manifest.leaf.security/slither':            'Résumé du rapport Slither',
  'manifest.leaf.security/audits':             'Séquence d’audits',
  'manifest.leaf.security/reporting':          'Signaler une vulnérabilité',
  'manifest.leaf.risks':                       'Registre des risques',
  'manifest.leaf.future/roadmap':              'Feuille de route',
  'manifest.leaf.future/research':             'Questions de recherche ouvertes',
  'manifest.leaf.literature':                  'Articles et références',
  'manifest.leaf.glossary':                    'Glossaire',
  'manifest.leaf.faq':                         'FAQ',
  'manifest.leaf.changelog':                   'Changelog',
};

export default messages;
